module.exports = __webpack_public_path__ + "img/Poorter_hotel-504.274b7da0.jpg";